import { Component, ViewChild, ElementRef, OnInit } from '@angular/core';
import * as bootstrap from 'bootstrap';
import { faGoogle } from '@fortawesome/free-brands-svg-icons';
import { DashboardComponent } from '../dashboard/dashboard.component';
@Component({
    selector: 'app-getpro',
    templateUrl: './getpro.component.html',
    styleUrls: ['./getpro.component.scss'],
})
export class GetproComponent {
    @ViewChild('GetproModal') GetproModal!: ElementRef; // Reference to the modal
    @ViewChild(GetproComponent) GetproInstance!: GetproComponent;

    openGetproModal() {
        const modalElement = this.GetproModal.nativeElement;
        const modalInstance = new bootstrap.Modal(modalElement);

        modalInstance.show();
    }
    closeGetproModal() {
        const modalElement = this.GetproModal.nativeElement;
        const modalInstance = bootstrap.Modal.getInstance(modalElement);
        if (modalInstance) {
            modalInstance.hide(); // Call hide() on the existing modal instance if it exists
        }
    }
}
